import { useCallback, useEffect, useState } from 'react';
import { DelayedJob, JobScheduler, JobStore } from '@stores/JobStore';

export const useAdminJobsController = () => {
  const [schedulers, setSchedulers] = useState<JobScheduler[]>([]);
  const [delayedJobs, setDelayedJobs] = useState<DelayedJob[]>([]);
  const [loading, setLoading] = useState(true);
  const [confirmDialog, setConfirmDialog] = useState<{
    open: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
  }>({ open: false, title: '', message: '', onConfirm: () => {} });

  const jobStore = new JobStore();

  const fetchData = useCallback(async () => {
    setLoading(true);
    const [schedulerRes, delayedRes] = await Promise.all([jobStore.getSchedulers(), jobStore.getDelayedJobs()]);
    if (schedulerRes.status === 'SUCCESS' && schedulerRes.result) {
      setSchedulers(schedulerRes.result);
    }
    if (delayedRes.status === 'SUCCESS' && delayedRes.result) {
      setDelayedJobs(delayedRes.result);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleRemoveScheduler = (scheduler: JobScheduler) => {
    setConfirmDialog({
      open: true,
      title: 'Remove Job Scheduler',
      message: `Are you sure you want to remove scheduler "${scheduler.name}" (key: ${scheduler.key})? This will stop all future scheduled runs and remove its next queued instance. This cannot be undone.`,
      onConfirm: async () => {
        await jobStore.removeScheduler(scheduler.key);
        setConfirmDialog((prev) => ({ ...prev, open: false }));
        await fetchData();
      },
    });
  };

  const handleCloseDialog = () => {
    setConfirmDialog((prev) => ({ ...prev, open: false }));
  };

  return {
    schedulers,
    delayedJobs,
    loading,
    confirmDialog,
    handleRemoveScheduler,
    handleCloseDialog,
    refresh: fetchData,
  };
};
